export default __webpack_public_path__ + "static/logo-ad-elearning-10ba0403a572f81643589978f01f2870.png";